/*
 * @Author: your name
 * @Date: 2020-05-17 17:00:00
 * @LastEditTime: 2020-05-21 23:25:40
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /healthy/src/framework/model/FunctionItem.ts
 */ 
import { MenuType } from './enum'
/**
 * 左侧功能定义
 * @author liuzhiqiang
 */
export default class FunctionItem {
    /**
     * 功能ID
     */
    public functionId: string;
    /**
     * 名称
     */
    public name: string;
    /**
     * 定义url是路由还是地址（不带协议符）
     */
    public type: string;
    /**
     * 路由或URL
     */
    public icon: string;
    /**
     * 路由或URL
     */
    public url: MenuType;
    /**
     * type=TYPE_GROUP时的子级菜单
     */
    // List<FunctionItem> subFunctionItems;
    public subFunctionItems: FunctionItem[]
    constructor({ functionId = '', name = '', type = '',icon = '', url = MenuType.TYPE_URL, subFunctionItems = [] }={}) {
        this.functionId = functionId;
        this.name = name;
        this.type = type;
        this.icon = icon;
        this.url = url;
        this.subFunctionItems = subFunctionItems||[];
    }
}